import { Link } from 'react-router-dom'
import { Muted } from '@/components/ui'

const STEPS = [
  { key: 'dominio', label: '1. Domínio', to: '/app/rh/importar', hint: 'WK1 / CCusto' },
  { key: 'rhid', label: '2. RHID', to: '/app/rh/importar/rhid', hint: 'CPF, matrícula, PIS' },
  { key: 'bitrix', label: '3. Bitrix', to: '/app/rh/importar/bitrix', hint: 'E-mail, foto, ativo/desligado' },
  { key: 'duplicados', label: '4. Duplicados', to: '/app/rh/importar/duplicados', hint: 'Vincular / mesclar' },
] as const

export type ImportPipelineStep = (typeof STEPS)[number]['key']

export function ImportPipelineNav({ active }: { active: ImportPipelineStep }) {
  return (
    <nav className="hi-import-pipeline" aria-label="Sequência de importação">
      <Muted>Ordem recomendada para completar o cadastro:</Muted>
      <ol className="hi-import-pipeline-steps">
        {STEPS.map((s) => (
          <li key={s.key}>
            {s.key === active ? (
              <span className="hi-import-pipeline-current" aria-current="step">
                {s.label}
                <small>{s.hint}</small>
              </span>
            ) : (
              <Link className="hi-import-pipeline-link" to={s.to}>
                {s.label}
                <small>{s.hint}</small>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
